import PropTypes from 'prop-types';
import React from 'react';
import GroupSelector from '../GroupSelector';
import { ENTITLEMENTS } from '../utils/constants';
import withGS from '../withGShoc';

class ProjectPermissions extends React.Component {

    handleToggle = (groupIRI) => {
        const { hasGroup } = this.props.data;
        const currentIndex = hasGroup ? hasGroup.indexOf(groupIRI) : -1;
        currentIndex === -1 ? this.props.onAdd('hasGroup', groupIRI) : this.props.onDelete('hasGroup', groupIRI);
    };

    render() {

        const { data, entitlements } = this.props;

        const isReadOnly = !entitlements || !entitlements.includes(ENTITLEMENTS.EDIT_GROUP);

        return (
            <div style={{ maxHeight: '400px' }}>
                <GroupSelector
                    isReadOnly={isReadOnly}
                    groupList={data.hasGroup ? data.hasGroup : []}
                    handleToggle={this.handleToggle}
                    adminIsEditable={false} />
            </div>
        );
    }
}

ProjectPermissions.propTypes = {
    onAdd: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    entitlements: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired
};

export default withGS(ProjectPermissions);